(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['module', 'exports', './parse', './example', './examples', './options', './option', './command', './help', './utils'], factory);else if ('undefined' != typeof exports) factory(module, exports, require('./parse'), require('./example'), require('./examples'), require('./options'), require('./option'), require('./command'), require('./help'), require('./utils'));else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.parse, global.example, global.examples, global.options, global.option, global.command, global.help, global.utils), global.index = mod.exports;
  }
})(this, function (module, exports, _parse, _example, _examples, _options, _option, _command, _help, _utils) {
  'use strict';

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function Args() {
    this.details = {
      commands: [],
      options: [],
      examples: []
    }, this.config = {
      help: !0,
      usageFilter: null,
      value: null,
      name: null,
      mainColor: 'yellow',
      subColor: 'dim'
    }, this.printMainColor = function (i) {
      return i;
    }, this.printSubColor = function (i) {
      return i;
    }, this.parent = module.parent;
  }

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports.default = Args;

  var _parse2 = _interopRequireDefault(_parse),
      _example2 = _interopRequireDefault(_example),
      _examples2 = _interopRequireDefault(_examples),
      _options2 = _interopRequireDefault(_options),
      _option2 = _interopRequireDefault(_option),
      _command2 = _interopRequireDefault(_command),
      _help2 = _interopRequireDefault(_help),
      _utils2 = _interopRequireDefault(_utils),
      publicMethods = {
    command: _command2.default,
    option: _option2.default,
    options: _options2.default,
    parse: _parse2.default,
    example: _example2.default,
    examples: _examples2.default,
    showHelp: _help2.default
  };

  for (var util in _utils2.default) {
    ({}).hasOwnProperty.call(_utils2.default, util) && (Args.prototype[util] = _utils2.default[util]);
  }

  for (var method in publicMethods) {
    ({}).hasOwnProperty.call(publicMethods, method) && (Args.prototype[method] = publicMethods[method]);
  }
});